import { UserMenu } from '../auth/UserMenu';
import { GlobalQuickSearch } from '../GlobalQuickSearch';
import { ReportIssueButton } from '../feedback/ReportIssueButton';
import { WebhookStatusIndicator } from '../WebhookStatusIndicator';
import { Wand2 } from 'lucide-react';
import { ViewModeSwitcher } from './ViewModeSwitcher';
import { useAppView } from '@/contexts/AppViewContext';

export function Header() {
  const { canPreviewViews, isStandardPreview, viewMode } = useAppView();

  return (
    <>
      <header className="bg-white shadow-sm relative z-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 min-w-0">
            {/* Logo section - fixed width on mobile, flexible on desktop */}
            <div className="flex items-center min-w-0">
              <Wand2 className="h-8 w-8 text-blue-600 flex-shrink-0" />
              <span className="ml-2 text-lg sm:text-xl font-bold text-gray-900 hidden sm:block truncate">
                Compliance Magic
              </span>
            </div>

            {/* Right section - properly spaced */}
            <div className="flex items-center gap-2 flex-shrink-0">
              {canPreviewViews && <ViewModeSwitcher />}
              {viewMode === 'elevated' && <WebhookStatusIndicator />}
              {viewMode === 'elevated' && <GlobalQuickSearch />}
              <ReportIssueButton />
              <UserMenu />
            </div>
          </div>
        </div>
      </header>
      {isStandardPreview && (
        <div className="relative z-10 border-b border-amber-200 bg-amber-50 px-4 py-2 text-center text-xs font-medium text-amber-900" role="status">
          You are previewing the standard user experience. Your Level 3 permissions are unchanged.
        </div>
      )}
    </>
  );
}
